const m = require('minthril');
const { component } = require('../../component');
const { SiteNavigation } = require('../../components/site-navigation');

function eventTime(event) {
  const timestamp = event.occurredAt;
  const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);
  return Number.isNaN(date.getTime()) ? 'Time unavailable' : date.toLocaleString();
}

function failedEvents(events) {
  return (events || [])
    .filter(event => event.type === 'refresh' && event.outcome === 'failed')
    .sort((left, right) => {
      const leftDate = left.occurredAt?.toDate?.() || new Date(left.occurredAt || 0);
      const rightDate = right.occurredAt?.toDate?.() || new Date(right.occurredAt || 0);
      return rightDate.getTime() - leftDate.getTime();
    });
}

function failureDetails(event) {
  if (event.apiFailures?.length) {
    return m('ul.route-logs__api-failures', event.apiFailures.map((failure, index) => m('li', {
      key: `${failure.method}:${failure.url}:${index}`
    }, [
      m('strong', `${failure.method} · ${failure.status}`),
      m('code', failure.url)
    ])));
  }

  return m('p.route-logs__message', event.errorMessage || 'The render failed without additional details.');
}

const RouteLogsPage = component((vnode, emit) => {
  let events = null;
  let error = null;
  let loading = false;
  let loadedPath = null;

  async function load(path, onLoad) {
    if (!onLoad || loading) return;
    loading = true;
    error = null;

    try {
      events = await onLoad(path);
      loadedPath = path;
    } catch (reason) {
      error = reason.message;
      events = [];
      loadedPath = path;
    } finally {
      loading = false;
      emit('redraw');
    }
  }

  return {
    oninit: ({ attrs }) => load(attrs.path, attrs.onLoad),
    onbeforeupdate: ({ attrs }) => {
      if (attrs.path !== loadedPath && !loading) load(attrs.path, attrs.onLoad);
    },
    view: ({ attrs }) => {
      const {
        site,
        path,
        sitesHref,
        overviewHref,
        routesHref,
        detailsHref
      } = attrs;
      const logs = failedEvents(events);
      const routeHref = `${detailsHref}?route=${encodeURIComponent(path)}`;

      return m('section.panel.site-detail.route-logs-page', [
        m(SiteNavigation, {
          breadcrumbs: [
            { label: sitesHref.startsWith('/admin') ? 'Admin' : 'Sites', href: sitesHref },
            { label: site.name, href: overviewHref },
            { label: 'Routes', href: routesHref },
            { label: path, href: routeHref },
            { label: 'Logs' }
          ],
          overviewHref,
          routesHref,
          current: 'routes'
        }),
        m('h2', `${site.name} route logs`),
        m('p.route-logs-page__path', m('code', path)),
        m('p.muted', 'Render failures and failed API requests recorded for this route.'),
        loading
          ? m('p.muted', 'Loading route logs…')
          : error
            ? m('p.route-logs-page__error', `Unable to load route logs: ${error}`)
            : logs.length
              ? m('ol.route-logs__list', logs.map((event, index) => m('li.route-logs__entry', {
                key: event.id || `${eventTime(event)}:${index}`
              }, [
                m('div.route-logs__heading', [
                  m('strong', 'Render failed'),
                  m('time', eventTime(event))
                ]),
                failureDetails(event),
                m('span.muted', `Triggered by · ${event.requestType || event.trigger || 'unknown'}`)
              ])))
              : m('p.muted', 'No failed renders appear in the recent activity for this route.'),
        m('a.route-logs-page__back', { href: routeHref }, 'Back to route details')
      ]);
    }
  };
});

module.exports = { RouteLogsPage };
